import { TEMPORARY_REDIRECT_STATUS } from '@glass/common/modules/http/statusCodes';
import { DEFAULT_RESUME_BUILDER_BASE_PATH } from '@glass/common/modules/pages/paths';
import { BASE_PATH_1_QUERY } from '@glass/common/modules/pages/queryParams';
import ResumeBuilderRouter from '@glass/web/modules/resumes/router/ResumeBuilderRouter';
import { isValidBuilderSectionStep } from '@glass/web/modules/resumes/router/stepData';

import { builderFirstStepParams } from '@glass/shared/modules/resumes/createBuilderFirstStepParams';
import redirect from '@glass/shared/modules/router/redirect';

const ensureValidBuilderStep = (context, query, { checkQuery } = {}) => {
  if (isValidBuilderSectionStep(query, { checkQuery })) {
    return null;
  }
  return redirect(
    context,
    ResumeBuilderRouter.getResumeBuilderUrl({
      ...builderFirstStepParams,
      [BASE_PATH_1_QUERY]: query[BASE_PATH_1_QUERY] || DEFAULT_RESUME_BUILDER_BASE_PATH,
    }),
    {
      status: TEMPORARY_REDIRECT_STATUS,
    },
  );
};

export default ensureValidBuilderStep;
